const MAIN_SELECTOR = '#main';

export const addClassToIframe = () => {
    const main = document.querySelector(MAIN_SELECTOR);
    if (!main) return;
    const playBtn = document.querySelector(".cds-video__wrapper .cds-video__btn_wrapper .cds-btn");
    if (playBtn) {
        playBtn.addEventListener("click", () => {
            setTimeout(() => {
                const iframe = document.querySelector(".cds-video__frame");
                const src = iframe?.attributes.getNamedItem('src')?.value;
                if (src?.startsWith('https://www.youtube-nocookie.com')) {
                    if (iframe) {
                        iframe.className = "optanon-category-C0004 ot-vscat-C0004 cds-video__frame";
                    }
                }
            })
        })
    }

}